<template>
  <el-container>
    <el-header style="height: 66px">
      <el-col class="logo">
        <img :src="logo" v-if="logo" />
      </el-col>
      <el-dropdown placement="bottom-start" @command="handleCommand">
        <el-col class="userInfo">
          <img src="../components/images/header.png" />
          <span>{{ loginInfo.name }}</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-col>

        <el-dropdown-menu slot="dropdown">
          <!-- <el-dropdown-item command="a">修改信息</el-dropdown-item>
          <el-dropdown-item command="b">修改密码</el-dropdown-item> -->
          <el-dropdown-item command="c">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- <div class="fullscreen" @click="toggleFullScreen"></div> -->
    </el-header>
    <el-container>
      <el-aside>
          <el-menu class="el-menu" text-color="#666" active-text-color="#0083EA" ref="menu">
            <template v-for="(item, index) in options" v-if="!item.hidden">
                <el-submenu v-if="item.children.length > 1&&permission.indexOf(item.id) !== -1 " :index="item.path" :class="{'active-menu': item.children.some(child => child.path === $route.path)}" style="color:#333">
                    <template slot="title">
                        <i :class="item.iconCls" class="iconFonts"></i>
                        <span>{{item.name}}</span>
                    </template>
                    <el-menu-item v-for="(child, childIndex) in item.children" :key="childIndex" @click="$router.push(child.path)" :class="child.path === $route.path ? 'active-menu' : ''" style="color:#333" v-if="!child.id||permission.indexOf(child.id)!=-1">
                        <span>{{child.name}}</span>
                    </el-menu-item>
                </el-submenu>

                <el-menu-item @click="handleMenuItemClick(item.path)" :class="item.path === $route.path ? 'active-menu' : ''" style="color:#333" v-if="permission.indexOf(item.id) !== -1 && item.children.length<2">
                    <i :class="item.iconCls" class="iconFonts"></i>
                    <span>{{item.name}}</span>
                </el-menu-item>
            </template>
        </el-menu>
      </el-aside>
      <el-main>
        <div class="grid-content bg-purple-light">
          <el-col :span="24" class="content-wrapper">
            <transition name="fade" mode="out-in">
              <router-view></router-view>
            </transition>
          </el-col>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { axiosPost } from "@/assets/ajaxFn.js";
export default {
  data() {
    return {
      logo:'',
      loginInfo:JSON.parse(sessionStorage.getItem('loginData')),
      options: [],
      opends: ["1"],
      permission:JSON.parse(sessionStorage.getItem('permission'))
    };
  },
  methods: {
    handleCommand(command) {
      if (command === "c") {
        this.$confirm("确定要退出到登录页面吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
            axiosPost("/api/passport/logout").then((res) => {
              if (res.code == 0) {
                this.$router.push("/Login");
              }
            });
          })
          .catch(() => {});
      }
      if (command === "a") {
        this.$router.push("/update");
      }
      if (command === "b") {
        this.$router.push("/updatePwd");
      }
    },
    handleMenuItemClick(path) {
        this.$router.push(path)
    },
    toggleFullScreen() {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();

      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        }
      }
    },
  },
  mounted() {
    this.options = this.$router.options.routes;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Home.vue